import React from 'react'
import { Result, Button } from 'antd'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { FlexRow } from '../Components/FlexboxReusables/FlexItems'

const NotFound: React.FC = () => {
  return (
    <>
      <FlexRow height='90vh' alignItems='center'>
        <Result
          status="404"
          title="404"
          subTitle={<FormattedMessage id="pageNotFound.message" />}
          extra={
            <Link to="/">
              <Button type="primary">
                <FormattedMessage id="pageNotFound.backToHome" />
              </Button>
            </Link>
          }
        />
      </FlexRow>
    </>
  )
}

export default NotFound
